import { ImageExtendedAttributes } from '../interfaces/ImageExtendedAttributes'

export const cleanImagePercentage = (value: number): number =>
  Math.round(Math.min(Math.max(value, 1), 100))
export const cleanImageSize = (value: number): number =>
  Math.round(Math.min(Math.max(value, 1), 12))
export const getImagePercentage = (value: number): number =>
  cleanImagePercentage((cleanImageSize(value) / 12) * 100)
export const getImageSize = (value: number): string => cleanImageSize((value / 100) * 12).toString()

export const generateImageStyles = ({
  alignment,
  float,
  size,
}: Partial<ImageExtendedAttributes>): string => {
  const styles: string[] = [
    'position: relative',
    'margin-top: 1rem',
    'margin-bottom: 1rem',
    'padding: 0.5rem',
    'display: block',
  ]
  if (size) styles.push(`width: ${getImagePercentage(Number(size))}%`)
  switch (alignment) {
    case 'left':
      styles.push('margin-right:auto')
      styles.push('margin-left:0')
      styles.push('max-width: 100%')
      styles.push('box-sizing: border-box')
      break
    case 'center':
      styles.push('margin-right:auto')
      styles.push('margin-left:auto')
      styles.push('max-width: 100%')
      styles.push('box-sizing: border-box')
      break
    case 'right':
      styles.push('margin-right:0')
      styles.push('margin-left:auto')
      styles.push('max-width: 100%')
      styles.push('box-sizing: border-box')
      break
    default:
      styles.push('margin-right:auto')
      styles.push('margin-left:0')
      styles.push('max-width: 100%')
      styles.push('box-sizing: border-box')

      break
  }
  switch (float) {
    case 'left':
      styles.push('float: left')
      break
    case 'right':
      styles.push('float: right')
      break
    default:
      styles.push('float: none')
      break
  }
  return styles.join(';')
}
